module.exports = __webpack_public_path__ + "static/media/20170617-202125-021.be4e8300.png";